import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmReasonTypeExtended } from '../interfaces/IKnmReasonTypeExtended';
import { IGenericReason } from '../interfaces/IGenericReason';
import { IKnmReasonType } from '../interfaces/IKnmReasonType';

export async function fetchKnmReasonTypes(knmTypeId: number): Promise<IKnmReasonTypeExtended[]> {
  return apiGet<IKnmReasonTypeExtended[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-reason-types/${knmTypeId}`,
  );
}

export async function fetchErknmKnmErvkConditions(
  knoVersionId: string,
  supervisionVersionId: string,
  typeErknmCode: string,
  knmKindId: string | undefined,
): Promise<IKnmReasonTypeExtended[]> {
  const queryParams = new URLSearchParams();

  queryParams.append('knoVersionId', knoVersionId);
  queryParams.append('supervisionVersionId', supervisionVersionId);
  queryParams.append('currentConditionId', '');
  queryParams.append('typeErknmCode', typeErknmCode);
  knmKindId && queryParams.append('knmKindId', knmKindId);

  return apiGet<IKnmReasonTypeExtended[]>(
    `${getServiceBaseURL(
      APIServiceEnum.BASE_SERVICE,
    )}/dictionaries/constraint/get-available-application-conditions?${queryParams}`,
  );
}

export async function fetchPmErvkConditions(
  knoVersionId: string,
  supervisionVersionId: string,
  profKindId?: string,
  uuidFederalLaw?: string,
): Promise<IKnmReasonTypeExtended[]> {
  const queryParams = new URLSearchParams();

  queryParams.append('knoVersionId', knoVersionId);
  queryParams.append('supervisionVersionId', supervisionVersionId);
  queryParams.append('currentConditionId', '');
  profKindId && queryParams.append('profKindId', profKindId);
  uuidFederalLaw && queryParams.append('uuidFederalLaw', uuidFederalLaw);

  return apiGet<IKnmReasonTypeExtended[]>(
    `${getServiceBaseURL(
      APIServiceEnum.BASE_SERVICE,
    )}/dictionaries/constraint/get-available-application-conditions-pm?${queryParams}`,
  );
}

export async function fetchErpKnmErvkConditions(
  knoVersionId: string,
  supervisionVersionId: string,
  knmTypeCode: string,
  federalLaw: string,
  knmKindId: string | undefined,
) {
  const queryParams = new URLSearchParams();

  queryParams.append('knoVersionId', knoVersionId);
  queryParams.append('supervisionVersionId', supervisionVersionId);
  queryParams.append('currentConditionId', '');
  queryParams.append('knmTypeCode', knmTypeCode);
  queryParams.append('uuidFederalLaw', federalLaw);
  knmKindId && queryParams.append('knmKindId', knmKindId);

  return apiGet<IKnmReasonTypeExtended[]>(
    `${getServiceBaseURL(
      APIServiceEnum.BASE_SERVICE,
    )}/dictionaries/constraint/get-available-application-conditions?${queryParams}`,
  );
}

export async function fetchGenericReasons(isDecision?: boolean): Promise<IGenericReason[]> {
  const queryParams = new URLSearchParams();

  if (isDecision !== undefined) {
    queryParams.append('isDecisionPassport', isDecision ? 'true' : 'false');
  }

  return apiGet<IGenericReason[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/dictionaries/constraint/get-generic-reasons?${
      queryParams.toString().length ? `${queryParams}` : ''
    }`,
  );
}

export async function fetchConditionTypesDictionary(isKnm?: string): Promise<IKnmReasonType[]> {
  const queryParams = new URLSearchParams();

  if (isKnm !== undefined) {
    queryParams.append('systemType', isKnm);
  }

  return apiGet<IKnmReasonType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE, false)}/dictionaries/constraint/get-all-knm-reason-types?${
      queryParams.toString().length ? `${queryParams}` : ''
    }`,
  );
}

export async function fetchErknmDecisionErvkConditions(
  knoVersionId: string,
  supervisionVersionId: string,
  decisionKindId: string,
): Promise<IKnmReasonTypeExtended[]> {
  const queryParams = new URLSearchParams();

  queryParams.append('knoVersionId', knoVersionId);
  queryParams.append('supervisionVersionId', supervisionVersionId);
  queryParams.append('decisionKindId', decisionKindId);

  return apiGet<IKnmReasonTypeExtended[]>(
    `${getServiceBaseURL(
      APIServiceEnum.BASE_SERVICE,
    )}/dictionaries/constraint/get-available-application-conditions-decision?${queryParams}`,
  );
}
